<div class="categorie-card" [class]="card.tipoCard">
    <div class="div-header-card">
        <div class="titulo-icone-periodo">
            <div class="card-titulo-icone">
                <span class="icone-card">
                    <img [src]="iconeCaminho" alt="">
                </span>
                <h1 class="titulo-card">{{ card.titulo }}</h1>
            </div>
            <span class="texto-periodo">
                <p>{{ card.periodo }}</p>
            </span>
        </div>

        <h2 class="subtitulo-card">{{ card.subtitulo }}</h2>
    </div>

    <div class="botoes">
        @if(card.botaoHabilitado === true && card.tipoCard == "ppa"){
            <button routerLink="/ppa/participacao" class="botao-participe habilitado">Participe</button>
        }
        @if(card.botaoHabilitado === true && card.tipoCard == "loa"){
            <button routerLink="/loa/participacao" class="botao-participe habilitado">Participe</button>
        }
        @if(card.botaoHabilitado !== true){
            <button class="botao-participe desabilitado" disabled>Participe</button>
        }
        @if(card.tipoCard == "ppa"){
            <button routerLink="/ppa" class="botao-pagina-ppa">Conheça o PPA</button>
        }
    </div>

    <div class="lista-objetivos">
        <p>Objetivos:</p>
        <ul>
            @for(obj of card.objetivos; track obj){
                <li>{{obj}}</li>
            }
        </ul>
    </div>
</div>
